import { render, staticRenderFns } from "./CardLogsDialog.vue?vue&type=template&id=daf5932a"
import script from "./CardLogsDialog.vue?vue&type=script&lang=js"
export * from "./CardLogsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports